import { Component } from '@angular/core';
import { UserProfile, UserProfileDefaultValues } from '../userdetail';
import { UserService } from 'src/app/services/user.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    standalone: false
})
export class UserProfileComponent {

  userProfile:UserProfile=UserProfileDefaultValues();
  translations: any;
  constructor(private userservice:UserService, private translationService: TranslationService ) { }
  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });
    this.userservice.getUserProfile().subscribe({
      next: (data) => {
        this.userProfile=data;
      }
    })
  }
}
